/**
 * 밝은 화면 / 어두운 화면 전환 버튼.
 *
 * 지금 어떤 화면인지는 <html data-theme> 이 들고 있다. 그 값은 첫 화면이 그려지기
 * 전에 <head> 인라인 스크립트가 이미 정해 뒀으므로(inc/theme-mode.php) 여기서는
 * 바꾸기만 한다 — 화면이 번쩍이지 않게 하려면 그 순서를 지켜야 한다.
 *
 * 고른 값은 localStorage 에 남긴다. 고른 적이 없으면 기기 설정을 따르고,
 * 기기 설정이 도중에 바뀌면 그때도 따라간다(직접 고른 뒤에는 따라가지 않는다).
 */
const DARK_QUERY = '(prefers-color-scheme: dark)';

const InitThemeToggle = () => {
  const buttons = [...document.querySelectorAll('[data-theme-toggle]')];
  const root = document.documentElement;
  const key = window.qrshopAcademy?.themeKey || 'qrshop-academy-theme';

  if (!buttons.length) {
    return;
  }

  const read = () => {
    try {
      return localStorage.getItem(key);
    } catch {
      return null; // 저장소를 못 읽는 환경 — 이번 방문 동안만 유지된다
    }
  };

  const apply = (mode, { remember = true } = {}) => {
    root.dataset.theme = mode;

    // 아이콘은 CSS 가 바꾼다. 여기서는 읽어 주는 이름만 맞춘다.
    const label = mode === 'dark' ? '밝은 화면으로 전환' : '어두운 화면으로 전환';

    buttons.forEach((button) => {
      button.setAttribute('aria-label', label);
      button.title = label;
    });

    if (!remember) {
      return;
    }

    try {
      localStorage.setItem(key, mode);
    } catch {
      // 저장만 실패할 뿐 전환은 이미 끝났다
    }
  };

  // <head> 가 정해 둔 값에 버튼 이름을 맞춰 둔다(서버는 어떤 화면인지 알 수 없다).
  apply(root.dataset.theme === 'dark' ? 'dark' : 'light', { remember: false });

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      apply(root.dataset.theme === 'dark' ? 'light' : 'dark');
    });
  });

  window.matchMedia(DARK_QUERY).addEventListener('change', (event) => {
    if (read()) {
      return; // 직접 고른 사람의 선택을 기기 설정이 뒤집지 않게 한다
    }

    apply(event.matches ? 'dark' : 'light', { remember: false });
  });
};

export default InitThemeToggle;
